export default __webpack_public_path__ + "static/media/priscila-almeida-book.bd54cfe9.png";